import React from 'react';
import { withAuthorization } from '../../components/Session';
//import { withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';
import * as ROUTES from '../../constants/routes';


class AdminPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      users: [],
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.props.firebase.users().on('value', snapshot => {
      const usersObject = snapshot.val();

      const usersList = !!usersObject ? Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      })) : [{uid:123,email:"Nothing to show",username:"nothing"}];



      this.setState({
        users: usersList,
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }



  render() {
    const { users, loading } = this.state;

    return (
      
        <div>
          <h1>Admin</h1>
          <p>
            Restricted area! Only users with the admin role are authorized.
          </p>
          {loading && <div>Loading ...</div>}

          <UserList users={users} />
        </div>
      
    );
  }
}

const UserList = ({ users }) => (
  <ul>
    {users.map(user => (
      <li key={user.uid}>
        <span>
          <strong>ID:</strong> {user.uid}
        </span>
        <span>
          <strong>E-Mail:</strong> {user.email}
        </span>
        <span>
          <strong>Username:</strong> {user.username}
        </span>
      </li>
    ))}
  </ul>
);


const condition = authUser => authUser && !!authUser.roles && !!authUser.roles[ROLES.ADMIN];

export default withAuthorization(condition,ROUTES.HOME)(AdminPage);

/*
const AdminPage = () => (
  <div>
    <h1>Admin</h1>
    <p>
      Restricted area! Only users with the admin role are authorized.
    </p>
  </div>
);

const condition = authUser =>
  authUser && !!authUser.roles[ROLES.ADMIN];

export default withAuthorization(condition)(AdminPage);
*/